import { useMemo } from 'react'
import PageMetaData from '@v4/utils/data/PageMetaData'

const useVideoPreview = ({ image, video }) => {
	return useMemo(() => {
		const videoValue = video?.metaValue

		if (image?.image) return image

		if (!videoValue) return undefined

		const getThumbnailUrl = embedCode => {
			const youtubeRegex = /youtube\.com\/embed\/([a-zA-Z0-9_-]+)/
			const wistiaRegex = /wistia\.com\/embed\/medias\/([a-zA-Z0-9_-]+)/

			const youtubeMatch = embedCode.match(youtubeRegex)
			const wistiaMatch = embedCode.match(wistiaRegex)

			if (youtubeMatch && youtubeMatch[1]) {
				const videoId = youtubeMatch[1]
				return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
			}
			if (wistiaMatch && wistiaMatch[1]) {
				const hashedId = wistiaMatch[1]
				return `https://fast.wistia.com/embed/medias/${hashedId}/thumbnail`
			}
			return null
		}

		const src = getThumbnailUrl(videoValue)

		if (!src) {
			return undefined
		}

		return new PageMetaData().fill({ meta_value: src })
	}, [image, video.metaValue])
}

export default useVideoPreview
